import React from 'react';

export default function WhySection() {
  return (
    <section id="why" className="sec">
      <div className="why-grid">
        <div className="rl">
          <div className="kicker k-gold">Why Auralux</div>
          <h2 className="title lt">
            The standard
            <br />
            others are
            <br />
            <em>measured by</em>
          </h2>
          <p className="why-desc">
            We don&apos;t simply manufacture masterbatch. We engineer a partnership built on technical depth, regulatory
            expertise, and a shared commitment to quality — from your first trial to every production batch thereafter.
          </p>
          <div className="why-bars" id="pbars">
            <h4>Performance vs. Market Average</h4>
            <div className="bar">
              <div className="bar-lbl">
                <span>Color Consistency (ΔE)</span>
                <span>98.6%</span>
              </div>
              <div className="bar-bg">
                <div className="bar-fill f-gd" data-w="98.6" />
              </div>
            </div>
            <div className="bar">
              <div className="bar-lbl">
                <span>Sustainability Index</span>
                <span>88%</span>
              </div>
              <div className="bar-bg">
                <div className="bar-fill f-gr" data-w="88" />
              </div>
            </div>
            <div className="bar">
              <div className="bar-lbl">
                <span>Global Certifications</span>
                <span>92%</span>
              </div>
              <div className="bar-bg">
                <div className="bar-fill f-bl" data-w="92" />
              </div>
            </div>
            <div className="bar">
              <div className="bar-lbl">
                <span>Customer Retention</span>
                <span>96%</span>
              </div>
              <div className="bar-bg">
                <div className="bar-fill f-gd" data-w="96" />
              </div>
            </div>
          </div>
        </div>
        <div className="why-pts rr">
          <div className="why-pt">
            <div className="why-i">1</div>
            <div>
              <h4>Technical Partnership, Not Just Supply</h4>
              <p>
                Our applications engineers work alongside your team — from raw material selection and trial line
                commissioning through full scale-up and reformulation as your needs evolve.
              </p>
            </div>
          </div>
          <div className="why-pt">
            <div className="why-i">2</div>
            <div>
              <h4>Custom Formulation in 72 Hours</h4>
              <p>
                Submit a sample, colorimetric target, or specification sheet. AI-assisted matching delivers a trial
                masterbatch within 72 business hours, ready for immediate press trials.
              </p>
            </div>
          </div>
          <div className="why-pt">
            <div className="why-i">3</div>
            <div>
              <h4>Regulatory Compliance Built In</h4>
              <p>
                Every formulation is pre-screened against REACH, FDA, RoHS, HALAL, FSSAI, and food-contact regulations.
                Full compliance documentation ships with every single order.
              </p>
            </div>
          </div>
          <div className="why-pt">
            <div className="why-i">4</div>
            <div>
              <h4>Supply Security by Architecture</h4>
              <p>
                Dual-source raw materials, regional safety stock, and a distributed multi-plant network ensure uninterrupted
                supply through disruptions, shortages, and demand spikes.
              </p>
            </div>
          </div>
          <div className="why-pt">
            <div className="why-i">5</div>
            <div>
              <h4>Verified Quality, Every Shipment</h4>
              <p>
                Full CoA, spectrophotometric data, and a QR-linked quality passport with every batch. ΔE &lt; 0.5
                guaranteed or we reformulate at no charge. No exceptions — ever.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
